import {Component, inject} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {OAuthService} from 'angular-oauth2-oidc';
import {PortalIdpService} from '../services/portal-idp.service';
import {environment} from '../../environments/environment';
import {CommonModule} from '@angular/common';
import {FooterComponent} from './footer/footer.component';
import {FormsModule} from '@angular/forms';
import {TokenRefreshService} from '../services/token-refresh.service';
import {safeReturnPath} from '../services/return-path';

/**
 * The page the login round trip returns to (its OAuth state): the page in the address bar. Not router.url:
 * while logged out, the router's URL was not the deep link in the address bar (a reloaded PO item page
 * returned to "/", which lands on the welcome page and its monitoring overlay), so the address bar is the
 * source. After an idle logout the address bar holds the page the user was on (VTK-3611). Only a route of
 * this app is used.
 */
export function loginState(currentHash: string): string {
  return safeReturnPath(currentHash.replace(/^#/, '')) || '/';
}

@Component({
  selector: 'login-page',
  templateUrl: 'login-page.component.html',
  styleUrls: ['login-page.component.scss'],
  imports: [CommonModule, FooterComponent, FormsModule]
})
export class LoginPageComponent {
  idp: string
  basehost = environment.production ? '.content.castlabs.com' : '.content-stag.castlabs.com';

  readonly localDev = environment.localDev;
  readonly hasEnv = !!environment.env_name;
  localEnvInput: string = localStorage.getItem('local-dev-env') ?? '';

  constructor(public oAuthService: OAuthService, public router: Router, portalIdp: PortalIdpService) {
    this.idp = portalIdp.getIdpName()
  }

  login() {
    this.oAuthService.initLoginFlow(loginState(location.hash), {});
  }

  selectEnv(): void {
    const env = this.localEnvInput.trim();
    if (!env) return;
    localStorage.setItem('local-dev-env', env);
    window.location.reload();
  }

  protected readonly loginError = inject(TokenRefreshService).loginError;
  protected readonly window = window;
  protected readonly location = location;
}
